<div class="container-fluid py-4" *ngIf="post">
  <div class="pt-4 pb-3">
    <app-breadcrumb-navigation
      [showPreviousPage]="isAuthenticated && !isAdminSession"
      [link]="LINK_POSTS"
      [dataTestId]="'posts-link'"
      [pageToNavigateTitle]="'PROFILE_NAVIGATION_POSTS'"
      [pageTitle]="post.title"
      [titleDataTestId]="'post-detail-title'"
    ></app-breadcrumb-navigation>
    <button
      *ngIf="post.permissions.update"
      data-test-id="btn-update"
      (click)="editPost()"
      type="button"
      class="btn btn-outline-primary me-3"
    >
      {{ 'BTN_EDIT' | translate }}
    </button>
    <button
      *ngIf="post.permissions.remove"
      class="btn btn-outline-primary me-3"
      type="button"
      data-test-id="btn-remove-post"
      (click)="onRemovePost()"
    >
      {{ 'POSTS_REMOVE_POST_TITLE' | translate }}
    </button>
  </div>
  <div class="d-flex flex-column py-2">
    <span class="mb-0">
      <label class="form-label">{{ post.social_context.entity_type }}:</label>
      <a
        [attr.data-test-id]="'context-entity-' + post.social_context.entity_id"
        [routerLink]="buildContextEntityLink(post.social_context)"
      >
        {{ post.social_context.entity_title }}
      </a>
    </span>
    <app-profile-link
      [dataTestId]="'post-detail-author-username'"
      [cssStyles]="'username mb-0'"
      [status]="getStatus"
      [userId]="post.creator.user_id"
      [text]="post.creator.displayed_name"
    ></app-profile-link>
    <p data-test-id="post-detail-date">
      {{ post.date | date: DATE_TIME_FORMAT_LONG }}
    </p>
  </div>
  <div class="d-flex flex-column">
    <p
      class="multi-line-text text-break post-content-container"
      [innerHTML]="post.text | replaceBrokenUrls | async"
      data-test-id="post-detail-text"
    ></p>
    <div *ngIf="post.permissions.view_comments">
      <div class="my-3" data-test-id="post-comments-length">
        {{ loadedComments.totalRootCommentsCount | number: DIGITS_REPRESENTATION_OPTIONS }}
        {{ 'POSTS_POST_DETAIL_INFO_COMMENTS_HINT' | translate }}
      </div>
      <hr class="mb-3" />
      <div class="col-lg-9 col-md-10 px-0 my-3">
        <app-comments
          [loadedComments]="loadedComments"
          [postPermissions]="post.permissions"
          (addComment)="onAddComment($event)"
          (removeComment)="onRemoveComment($event)"
          (loadMoreComments)="onLoadMoreComments($event)"
          (loadAllComments)="onLoadAllComments($event)"
          (dirtyForm)="setFormStatus($event)"
        ></app-comments>
      </div>
    </div>
    <div *ngIf="!post.permissions.view_comments">
      <hr class="mb-3" data-test-id="hidden-comment-section-hint" />
      <div class="text-muted" [innerHTML]="hiddenCommentHint"></div>
    </div>
  </div>
</div>
<div *ngIf="!post" class="spinner-grow text-primary load m-5" role="status" data-test-id="loading-spinner">
  <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
</div>
